import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../../../../shared/components';
import BasicRadioGroup from '../../../../shared/components/BasicRadioGroup';
import { BasicNotification } from '../../../../shared/components/Notification';
import { findMapId, findMapped } from '../../../../shared/misc/utils';
import { OperationBasicItem } from '../../../../services/types/Operation';
import { RelatedNotification } from './NotificationRelateds';

interface FlowDeleteModalProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  callback: (deleteType: string) => void;
  relatedOperations: OperationBasicItem[];
}

const FlowDeleteModal: React.FC<FlowDeleteModalProps> = (props) => {
  const { visible, setVisible, callback, relatedOperations } = props;
  const { t } = useTranslation();

  const DELETE_LAP = 'delete-lap';

  const [deleteOption, setDeleteOption] = useState(DELETE_LAP);

  const deleteAction = () => {
    setVisible(false);

    callback(deleteOption);
  };

  const radioItems = [{ id: 2, text: t('deleteLap'), htmlId: 'radioLap', mapped: DELETE_LAP }];

  const setSelectedDeleteOption = (radId: number) => {
    const value = findMapped(radioItems, radId);
    setDeleteOption(value);
  };

  const getRelatedNumbers = (relateds: OperationBasicItem[]) => {
    const opRelateds = relateds.map((x) => x.number).join(', ');

    return opRelateds;
  };

  return (
    <Modal
      title={t('deleteDocuments')}
      visible={visible}
      setVisible={setVisible}
      actions={[
        { text: t('cancel'), action: () => setVisible(false) },
        { text: t('delete'), action: () => deleteAction() },
      ]}
      onClosed={() => setVisible(false)}
      customClass="flow-delete-modal"
    >
      <>
        <div className="justify-content-left pl-2">
          <BasicRadioGroup
            name="select"
            elements={radioItems}
            onChange={setSelectedDeleteOption}
            value={findMapId(radioItems, deleteOption)}
            direction="vertical"
          />
        </div>
        <BasicNotification
          message={
            relatedOperations.length > 0
              ? t('deleteLapMessageWarningRelated')
              : t('deleteLapMessageWarning')
          }
          color="warning"
          icon="exclamation-triangle"
        />
        <br />
        {relatedOperations.length > 0 && (
          <RelatedNotification
            numbers={getRelatedNumbers(relatedOperations)}
            color="warning"
            icon="exclamation-triangle"
          />
        )}
      </>
    </Modal>
  );
};

export default FlowDeleteModal;
